import React, {useState, useEffect} from 'react';
import {
  View, 
  StyleSheet, 
  TouchableOpacity, 
  Text, 
  Dimensions
} from 'react-native';
import HomeHeader from '../components/HomeHeader';
import TransactionList from './transactions/TransactionList';
import ReceiptList from './transactions/ReceiptList';

const HEIGHT = Dimensions.get('window').height
const WIDTH = Dimensions.get('window').width;
const isWeb = WIDTH > 992;

const TransactionListScreen = (props) => {

  const [tab, setTab] = useState('transactions');

  return (
    <View style={styles.container}>
      <HomeHeader navigation={props.navigation}/>
      <View style={styles.tabs}>
        <TouchableOpacity
          onPress={() => setTab('transactions')}
          style={tab === 'transactions' && styles.activeTab}>
          <Text style={styles.tabHeader}>Transactions</Text>
        </TouchableOpacity>
        <TouchableOpacity
          onPress={() => setTab('receipts')}
          style={tab === 'receipts' && styles.activeTab}>
          <Text style={styles.tabHeader}>Receipts</Text>
        </TouchableOpacity>        
      </View>
      <View style={styles.content}>
        {tab == 'transactions' && <TransactionList />} 
        {tab == 'receipts' && <ReceiptList />}
      </View>
    </View>
  );
};

const styles = StyleSheet.create({
  container: {
    flex: 1,
    backgroundColor: '#202124'
  },
  content: {
    marginHorizontal: isWeb ? 64 : 16,
    marginVertical: 32,
  },
  activeTab: {
    borderBottomColor: '#fd6060',
    paddingBottom: 18,
    borderBottomWidth: isWeb ? 3 : 2,
  },
  tabs: {
    flexDirection: 'row',
    justifyContent: 'space-evenly',
    marginHorizontal: isWeb ? 64 : 16,
    borderBottomWidth: 1,
    borderColor: '#ccccccb0',
    marginTop: 16
  },
  tabHeader: {
    paddingHorizontal: 10,
    color: '#0092ed',
    fontWeight: 'bold',
    letterSpacing: 1,
    fontSize: isWeb ? 15 : 13,
  },
});

export default TransactionListScreen;
